import { styled } from '@mui/material/styles';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';

export const StyledPreviewDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    padding: theme.spacing(1),
    minWidth: '600px',
    maxWidth: '800px',
    backgroundColor: '#F9FBFA'
  }
}));

export const PreviewHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderBottom: '1px solid #E0E0E0',
  backgroundColor: '#fff',
  borderRadius: '16px 16px 0 0',
}));

export const PreviewContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const FormGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(3),
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
  }
}));

export const PreviewFieldWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const PreviewLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.875rem',
  color: '#444',
}));

export const FileUploadPreview = styled(Box)(({ theme }) => ({
  border: '2px dashed #BDBDBD',
  borderRadius: '8px',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fff',
  color: '#757575',
  cursor: 'pointer',
  '&:hover': {
    borderColor: '#5E8E7E',
    backgroundColor: '#F1F8F6',
  }
}));
